<template>
  <section class="sections-builder-logos">
    <div class="container">
      <div v-if="ads.length" class="row justify-between">
        <div class="col-12 col-md-9 col-lg-10">
          <div v-if="companyStore.companytData.hits.length" class="row justify-content-center">
            <TransitionGroup name="list">
              <div v-for="(hit, key) in companyStore.companytData.hits" :key="`builder-logo-${key}`" class="__builder-logo-item col-6 col-sm-4 col-md-4 col-lg-3 col-xl-2">
                <BuilderWidget widget-type="Logo" :builder="hit.document" :analytics-event-data="{displayedLocation: 'Builders page', position: (key + 1) as number}" />
              </div>
            </TransitionGroup>
          </div>
        </div>
        <div class="col-12 col-md-3 col-lg-2 __ad-container">
          <div class="row justify-content-center">
            <div v-for="(ad, key) in ads" :key="`ad-${key}`" class="col-6 col-sm-4 col-md-12 __ad-container-block">
              <AdWidget :listing="ad" />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-md-12">
          <div v-if="companyStore.companytData.hits.length" class="row justify-content-center">
            <TransitionGroup name="list">
              <div v-for="(hit, key) in companyStore.companytData.hits" :key="`builder-logo-${key}`" class="__builder-logo-item col-6 col-sm-4 col-md-3 col-lg-2">
                <BuilderWidget widget-type="Logo" :builder="hit.document" :analytics-event-data="{displayedLocation: 'Builders page', position: (key + 1) as number}" />
              </div>
            </TransitionGroup>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import {useCompanyStore} from '~/store/company';
import {Listing} from '~/@types/listing';
import {Ref} from 'vue';

// DATA Definitions
//----------------------------------------------------------------------------------------------------------------------
const companyStore = useCompanyStore();
const ads: Ref<Listing[]> = ref([]);
const {$ad} = useNuxtApp();

/**
 * @_MOUNTED Hook
 */
onMounted(() => {
  getAds();
});

/**
 * Get ads
 */
async function getAds () {
  const response = await $ad.search(['builders']);
  if (response && response.hits) {
    ads.value = response.hits.slice(0, 4).map((hit: any) => hit.document);
  }
}
</script>

<style lang="scss">
.sections-builder-logos {
  background: #fff;

  .__builder-logo-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;

    img {
      max-width: 100%;
      max-height: 80px;
      scale: 1;
      transition: scale 0.3s ease-in-out;
    }

    &:hover {
      img {
        scale: 1.15;
        transition: scale 0.3s ease-in-out;
      }
    }
  }

  .__ad-container {
    padding-top: 50px;

    &-block {
      margin: 0 12px 50px;
      width: 100%; // Ensure the block takes full width of its container
      position: relative;

      // Maintain aspect ratio
      &:before {
        content: '';
        display: block;
        padding-top: 121.03%; // Aspect ratio in percentage
      }

      // Assuming the ad content is absolutely positioned within the block
      .blocks-ad {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
}
</style>
